module.exports = __webpack_public_path__ + "static/media/SF-1-if-wrong.da0f4908.mp3";